import http, { type ApiEnvelope } from "./http";

export interface DomainProbeItem {
  url_base_id: number;
  url_base: string;
  status_code: number | null;
  is_ok: boolean | null;
  probed_at: number | null;
  probed_today: boolean;
  probe_state: string;
  state: string;
  error: string;
}

export interface DomainProbeBatch {
  batch_id: string | null;
  uid: number;
  status: string;
  probe_date: string;
  total: number;
  queued: number;
  skipped: number;
  done: number;
  ok: number;
  fail: number;
  created_at: number;
  updated_at: number;
  items: Record<string, DomainProbeItem>;
}

export interface DomainProbeResult {
  probe_date: string;
  total: number;
  probed: number;
  ok: number;
  fail: number;
  items: DomainProbeItem[];
  batch?: DomainProbeBatch;
}

export function fetchDomainProbe() {
  return http.get("/DomainProbe") as Promise<ApiEnvelope<DomainProbeResult>>;
}

export function runDomainProbe() {
  return http.post("/DomainProbe") as Promise<ApiEnvelope<DomainProbeBatch>>;
}

export function fetchDomainProbeProgress(batch_id?: string) {
  return http.get("/DomainProbeProgress", {
    params: batch_id ? { batch_id } : {}
  }) as Promise<ApiEnvelope<DomainProbeBatch>>;
}
